<template>
  <div class="app-main flex-column flex-row-fluid" style="margin: 0 auto;">
    <Header v-if="['IPAD', 'MOBILE'].includes(device)">
      <div v-if="$slots.previous" slot="previous" class="me-0">
        <slot name="previous"></slot>
      </div>

      <div v-if="$slots.left" slot="left" class="sidemenu-button">
        <a class="btn btn-sm btn-icon btn-info" :title="leftButtonName" @click.stop="toggleSidemenu('left');">
          <i class="bi bi-list p-0" style="font-size: 18px;"></i>
        </a>
      </div>

      <div v-if="$slots.right" slot="right" class="sidemenu-button ms-2">
        <a class="btn btn-sm btn-icon btn-info" :title="rightButtonName" @click.stop="toggleSidemenu('right');">
          <i class="bi bi-list p-0" style="font-size: 18px;"></i>
        </a>
      </div>
    </Header>
    
    <div v-if="device == 'WEB'" class="app-toolbar pt-4 pb-3">
      <div class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex align-items-center flex-wrap flex-grow-1">
          <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">{{ $route.meta.title }}</h1>
          <span v-if="$slots.sub_title" class="text-gray-600 fw-bold fs-7 ms-2"><slot name="sub_title"></slot></span>
        </div>
        <div class="d-flex align-items-center gap-2">
          <slot name="toolbar"></slot>

          <div v-if="$slots.left" class="sidemenu-button">
            <a class="btn btn-sm btn-icon btn-info" :title="leftButtonName" @click.stop="toggleSidemenu('left');">
              <i class="bi bi-list p-0" style="font-size: 18px;"></i>
            </a>
          </div>

          <div v-if="$slots.right" class="sidemenu-button">
            <a class="btn btn-sm btn-icon btn-info" :title="rightButtonName" @click.stop="toggleSidemenu('right');">
              <i class="bi bi-list p-0" style="font-size: 18px;"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content flex-column-fluid">
      <div class="app-container">
        <div class="d-flex flex-row">
          <!-- 사이드 메뉴 (왼쪽) -->
          <div class="sidemenu left">
            <div class="sidemenu-header">
              <div class="btn btn-xs btn-icon btn-color-gray-800 btn-active-color-primary close">
                <i class="bi bi-x fs-1" @click.stop="toggleSidemenu('left')"></i>
              </div>
            </div>
            <div class="sidemenu-body">
              <slot name="left"></slot>
            </div>
          </div>

          <!-- 컨텐츠 -->
          <div class="flex-column flex-row-fluid align-items-center flex-grow-1">
            <slot name="top"></slot>
            <slot name="content"></slot>
          </div>
          
          <!-- 사이드 메뉴 (오른쪽) -->
          <div class="sidemenu right exclude_close_overlays">
            <div class="sidemenu-header">
              <div class="btn btn-xs btn-icon btn-color-gray-800 btn-active-color-primary close">
                <i class="bi bi-x fs-1" @click.stop="toggleSidemenu('right')"></i>
              </div>
            </div>
            <div class="sidemenu-body">
              <slot name="right"></slot>
            </div>
          </div>

          <!-- 사이드 메뉴 backdrop -->
          <div class="sidemenu-backdrop b-sidebar-backdrop bg-dark"></div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";

export default {
  name: "layout",
  props: {
    leftButtonName: '',
    rightButtonName: '',
  },
  components: { Header },
  data: () => ({}),
  computed: {
    device() { return this.$getDevice(); },
  },
  mounted() {
    document.querySelector('.app-header').classList.remove('d-none');
  },
  methods: {
    toggleSidemenu(position) {
      document.querySelector(`.sidemenu.${position}`).classList.toggle('show');
      document.querySelector('.sidemenu-backdrop').classList.toggle('show');
    },
  },
}
</script>